export const consultantGettingStartedArticle = {
  title: 'AI Business Consultant: Getting Started',
  slug: 'consultant-getting-started',
  content: `AI Business Consultant: Getting Started

Use the AI Business Consultant to chat with specialist advisors, reference your business data, and execute tasks.

1) Open the consultant hub
- Go to /business-consultant.
- Accept the Terms of Service to enable the consultant.

2) Choose business context (optional)
- Use the business selector in the header to attach a business context.
- This context helps the consultant reference saved business data.

3) Start a new conversation
- Click “New Chat” in the header.
- The Chat tab is the primary workspace for asking questions and running actions.

4) Navigate tabs
- Chat: live conversation with the consultant.
- Knowledge: upload files for AI reference.
- History: reopen past conversations.
- Settings: tune AI features and digests.

Tips
- Use Cmd/Ctrl + K to open the command palette.
`,
};
